//= require window.requestanimationframe/requestanimationframe.js

$(function() {
  'use strict';

  var $window = $(window),
      $header = $('#header'),
      $sticky = $header.find('.js-sticky'),
      didScroll = true;

  $window.on('scroll', function(event) {
    didScroll = true;
  });

  (function loop () {
    requestAnimationFrame(loop);

    if(didScroll) {
      if($window.scrollTop() > 200) {
        $sticky.addClass('is-displayed');
      } else {
        $sticky.removeClass('is-displayed');
      }
    }

  })();

});
